import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_account_list = (search, page, page_size) => {
  // 后端使用POST方法，参数从Body JSON传递
  return api.post(`${ApiEndpointConstants.ACCOUNTMANAGE}`, {
    search,
    page,
    page_size,
  });
};
